import { type EventStatus, type ProgramEventStatus, isEventLive } from 'models';

export const useIsLiveStatus = ({
  endTime,
  startTime,
  status,
}: {
  endTime: Date;
  startTime: Date;
  status: EventStatus | ProgramEventStatus;
}) => isEventLive({ endTime, startTime }) && (status === 'published' || status === 'active');
